import React, { Component } from "react";
import _ from "lodash";

import QuantityAdjustmentArrow from "./components/quantityAdjustmentArrow/quantityAdjustmentArrow";

import "./lineItem.css";

class LineItem extends Component {
  render() {
    const lineItem = this.props.lineItem;
    // find price
    const price = lineItem.variant.price;

    return (
      <div className="lineItem" key={lineItem.id}>
        <div className="imageContainer">
          <img src={lineItem.variant.image.src} alt="Line Item" />
        </div>
        <div className="informationContainer">
          <p className="title">{lineItem.title}</p>
          <div className="variant">
            {lineItem.variant.selectedOptions.map(selectedOption => (
              <p>
                {selectedOption.name} : {selectedOption.value}
              </p>
            ))}
            <p>Price: ${price}</p>
          </div>
          <div className="quantity">
            <p>Quantity: {lineItem.quantity}</p>
            <QuantityAdjustmentArrow adjustment={1} lineItem={lineItem} />
            <QuantityAdjustmentArrow adjustment={-1} lineItem={lineItem} />
          </div>
        </div>
      </div>
    );
  }
}
export default LineItem;
